var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5147 18.5039C28.5147 19.3518 29.2275 20.0455 30.0988 20.0455H33.2672C34.1385 20.0455 34.8513 19.3518 34.8513 18.5039C34.8513 17.656 34.1385 16.9622 33.2672 16.9622H30.0988C29.2275 16.9622 28.5147 17.656 28.5147 18.5039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.281 25.9347C25.7582 26.613 25.9008 27.5535 26.5978 28.0468C27.4374 28.648 28.3246 29.2955 29.1642 29.9122C29.8612 30.421 30.8434 30.2822 31.3503 29.6039C31.3503 29.5885 31.3662 29.5885 31.3662 29.573C31.8889 28.8947 31.7464 27.9389 31.0493 27.4455C30.2097 26.8289 29.3226 26.1814 28.4988 25.5801C27.8018 25.0714 26.8196 25.2255 26.2968 25.9039C26.2968 25.9193 26.281 25.9347 26.281 25.9347Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.382 7.41929C31.382 7.40387 31.3662 7.40387 31.3662 7.38846C30.8434 6.71012 29.8612 6.57137 29.18 7.08012C28.3404 7.69679 27.4374 8.34429 26.6137 8.96096C25.9166 9.46971 25.7899 10.4255 26.3127 11.0885C26.3127 11.1039 26.3285 11.1039 26.3285 11.1193C26.8513 11.7976 27.8176 11.9364 28.5147 11.4276C29.3543 10.8264 30.2414 10.1635 31.081 9.54679C31.7622 9.05346 31.8889 8.09762 31.382 7.41929Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.673 13.8789H6.33631C4.59372 13.8789 3.16797 15.2664 3.16797 16.9622V20.0455C3.16797 21.7414 4.59372 23.1289 6.33631 23.1289H7.92047V27.7539C7.92047 28.6018 8.63335 29.2955 9.50464 29.2955C10.3759 29.2955 11.0888 28.6018 11.0888 27.7539V23.1289H12.673L20.5938 27.7539V9.25387L12.673 13.8789Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5542 18.5039C24.5542 16.4535 23.6354 14.6035 22.178 13.3393V23.653C23.6354 22.4043 24.5542 20.5543 24.5542 18.5039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.521e89a66b34923fb6dd499fc0f72943.svg";
export { ForwardRef as ReactComponent };